/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Verified_BusinessInputs */

const en_status_verified_business = /** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Entity`)
};

const es_status_verified_business = /** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entidad Verificada`)
};

const fr_status_verified_business = /** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entité vérifiée`)
};

const de_status_verified_business = /** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierte Entität`)
};

const id_status_verified_business = /** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitas Terverifikasi`)
};

/** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */
const ja_status_verified_business = en_status_verified_business;

/** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */
const zh_status_verified_business = en_status_verified_business;

/** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */
const ar_status_verified_business = en_status_verified_business;

/** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */
const it_status_verified_business = en_status_verified_business;

/** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */
const ru_status_verified_business = en_status_verified_business;

/** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */
const pt_status_verified_business = en_status_verified_business;

/** @type {(inputs: Status_Verified_BusinessInputs) => LocalizedString} */
const ko_status_verified_business = en_status_verified_business;

/**
* | output |
* | --- |
* | "Verified Entity" |
*
* @param {Status_Verified_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const status_verified_business = /** @type {((inputs?: Status_Verified_BusinessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Verified_BusinessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_verified_business(inputs)
	if (locale === "es") return es_status_verified_business(inputs)
	if (locale === "fr") return fr_status_verified_business(inputs)
	if (locale === "de") return de_status_verified_business(inputs)
	if (locale === "ja") return ja_status_verified_business(inputs)
	if (locale === "zh") return zh_status_verified_business(inputs)
	if (locale === "ar") return ar_status_verified_business(inputs)
	if (locale === "id") return id_status_verified_business(inputs)
	if (locale === "it") return it_status_verified_business(inputs)
	if (locale === "ru") return ru_status_verified_business(inputs)
	if (locale === "pt") return pt_status_verified_business(inputs)
	return ko_status_verified_business(inputs)
});